import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

import { withDefaults } from 'vue'
import type { StyleValue } from 'vue'


import { defineComponent } from 'vue'
const __default__ = defineComponent({
  components: { },
  name: 'popup-header',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    title: { default: '标题' },
    showClsoe: { type: Boolean, default: true },
    headerStyle: null
  },
  emits: ['close'],
  setup(__props: any, { emit: emits }) {

const props = __props as { title: string, showClsoe: boolean, headerStyle?: StyleValue };




function hidePopup() {
  emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "head-info van-hairline--bottom",
    style: _normalizeStyle(props.headerStyle)
  }, [
    _createTextVNode(_toDisplayString(props.title) + " ", 1),
    (__props.showClsoe)
      ? (_openBlock(), _createElementBlock("i", {
          key: 0,
          onClick: hidePopup
        }))
      : _createCommentVNode("", true)
  ], 4))
}
}

})